import React, { useState, useEffect } from 'react';
import { TextField, Autocomplete, Button, Box,useMediaQuery } from '@mui/material';
import axios from '../../axios.js';
import { useTheme } from '@mui/material/styles';
import Facets from '../../components/Facets/Facets';

export default function SearchBar2({ postSearchHandler, query,facets,filters,setFilters,color,source, isFrench }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [q, setQ] = useState(() => query || '');
  const [suggestions, setSuggestions] = useState([]);
const filter =
  source === "mrmr-eng"
    ? "source eq 'Standard, Leading Practices & Guidance'"
    : source === "mag-eng"
      ? `source eq 'CIM Magazine'`
      : "";

  const search = (value) => {
    postSearchHandler(value);
  };

  useEffect(() => {
    if (q) {
        axios.post('/api/suggest', { q, top: 5, suggester: 'sg', filter: filter,isFrench:isFrench})
      .then(response => {
          setSuggestions(response.data.result.suggestions.map(s => s.text));
      }).catch (error =>{
          console.log(error);
          setSuggestions([]);
        });
}}, [q,filter]);


  const onInputChangeHandler = (event, value) => {
    setQ(value);
  };


  const onChangeHandler = (event, value) => {

    setQ(value);
    search(value);
  };

  const onEnterButton = (event) => {
    // if enter key is pressed
    if (event.key === 'Enter') {
      search(q);
    }
  };

  const formatSuggestion = (text = '') => {
  if (!text) return '';

  const value = text.trim().toLowerCase();

  return value.charAt(0).toUpperCase() + value.slice(1);
};

  return (
    <div
      className="input-group"
      style={{ width: '100%'}}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', minWidth: '390px' }}>
     <Autocomplete
  freeSolo
  value={q}
  options={suggestions}
  onInputChange={onInputChangeHandler}
  onChange={onChangeHandler}
  disableClearable

  renderOption={(props, option) => (
    <li {...props}>
      {formatSuggestion(option)}
    </li>
  )}

  sx={{
    width: '100%',
    '& .MuiAutocomplete-endAdornment': {
      display: 'none',
    },
  }}

  slotProps={{
    popper: {
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 4],
          },
        },
      ],
      sx: {
        '& .MuiAutocomplete-option': {
          fontSize: isMobile ? '12px' : '16px',
        },
      },
    },
  }}

  renderInput={(params) => (
    <TextField
      {...params}
      id="search-box"
      className="form-control rounded-0"
      placeholder="Find articles, products, or topics..."
      onBlur={() => setSuggestions([])}
      onClick={() => setSuggestions([])}
      onKeyDown={onEnterButton}
      sx={{
        '& .MuiOutlinedInput-root': {
          height: '50px',

          '&.Mui-focused fieldset': {
            borderColor: '#9E9E9E',
          },
        },
      }}
    />
  )}
/>
      <div className="input-group-btn" style={{ marginLeft: '10px' ,display:'flex'}}>

        {isMobile?    <Facets 
                        facets={facets} 
                        filters={filters} 
                        setFilters={setFilters} 
                      />:<Button  className="clear-button" variant="contained"  onClick={() => {
     setQ(''); // Clear the query
    search(''); // Trigger the search with the empty query
  }} sx={{
          textTransform: 'capitalize',
            backgroundColor: '#fff',
            color:'black',
            marginRight:'10px',
            height: '50px', // Match TextField height
            '&:hover': {
              backgroundColor: '#fff',
              color:'black',
            },
          }}>Clear</Button>}
        <Button variant="contained"  className="search-button"onClick={() => {
          search(q)}
          }
          sx={{
            textTransform: 'capitalize',
            backgroundColor: color, // Button background color
            height: '50px', // Match TextField height
            '&:hover': {
              backgroundColor: '#0F0F2D', // Slightly darker shade for hover (optional)
            },
          }}
          >
          Search
        </Button>
      </div>
      </Box>
    </div>
  );
}